import { useCallback } from "react";

export const useFormHandler = (setFormData) => {
  const setNestedValue = useCallback((prevState, path, value) => {
    const keys = path.split(".");
    const updated = structuredClone(prevState);

    let current = updated;
    keys.slice(0, -1).forEach((key) => {
      if (!current[key]) current[key] = {};
      current = current[key];
    });

    current[keys[keys.length - 1]] = value;
    return updated;
  }, []);

  const handleNestedInputChange = useCallback((e) => {
    const { name, value, type } = e.target;

    const parsedValue =
      type === "radio" && (value === "true" || value === "false")
        ? value === "true"
        : value;

    setFormData((prev) => setNestedValue(prev, name, parsedValue));
  }, [setFormData, setNestedValue]);

  return {
    handleNestedInputChange,
  };
};